import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styles from "../ResetPin/resetPin.module.css"; // Import CSS module
import { acceptInvite, createAppUser, createNewPin, provisionUser, removeUser } from "../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import knowioLogo from '../assets/knowio-logo.png'
import resureLogo from '../assets/resure-logo.png'
import { Button } from "primereact/button";
import API from '../Api Methods/Api'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'react-phone-number-input';
import { Checkbox } from "primereact/checkbox";


const CreateUser = ({ HandleCloseModal, setSuccess, setFail, setReason, setNewUserEmail, apiData }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const company = useSelector(state => state.auth.companyName);
    const token = searchParams.get("token");
    let appName = "portal";
    if (appName == "RE:SURE") {
        appName = "RESURE"
    }

    let logoMapping = [
        knowioLogo,
        resureLogo
    ]

    let icon = appName == "RESURE" ? logoMapping[1] : logoMapping[0]

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [confirmEmail, setConfirmEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("+44");
    const [isAdmin, setIsAdmin] = useState(false)

    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const userID = useSelector(state => state.auth.userID);

    const validatePhoneNumber = (phoneNumber) => {
        return false
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (name == "") {
            setMessage("Please enter a name")
            return;
        }

        if (email == "") {
            setMessage("Please enter an email address")
            return;
        }

        if (email !== confirmEmail) {
            setMessage("Email addresses do not match")
            return;
        }

        if (!isValidPhoneNumber(phoneNumber)){
            setMessage("Please enter a valid phone number");
            return;
        }

        setLoading(true);

        try {
            const body = {
                email: email,
                name: name,
                appName: company,
                verified: "yes",
                phoneNumber: phoneNumber,
                createdBy: userID,
                isAdmin: isAdmin //bool
            }
            console.log(body);

            const response = await provisionUser(apiData, body, dispatch)
            if (response.success) {
                //close modal, show success
                HandleCloseModal()
                setNewUserEmail(email)
                setSuccess(true)
            } else {
                //show error 
                HandleCloseModal();
                setFail(true)
                setReason(response.msg)
            }
        } catch (error) {
            setMessage("Network error, please check your connection & try again. Error: " + error)
        }

        setLoading(false);
    };

    return (
        <div className={`${styles[appName]} ${styles.container}`}>

            <div className={`${styles.card} ${styles["GENERIC"]}`}>
                {message && <p className={styles.errorMessage}>{message}</p>}
                <h1 className={`${styles.title} ${styles["GENERIC"]}`}>Create account</h1>
                <p className={`${styles.subTitle} ${styles["GENERIC"]}`}>Enter their first and last name below</p>

                <input
                    type="text"
                    className={`${styles.inputField} ${styles["GENERIC"]}`}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Full Name"
                    required
                />

                <p className={`${styles.subTitle} ${styles[appName]}`}>Enter their email address</p>
                <input
                    type="text"
                    className={`${styles.inputField} ${styles["GENERIC"]}`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email address"
                    required
                />
                <input
                    type="text"
                    className={`${styles.inputField} ${styles["GENERIC"]}`}
                    value={confirmEmail}
                    onChange={(e) => setConfirmEmail(e.target.value)}
                    placeholder="Confirm email address"
                    required
                />

                <br></br>
                <p className={`${styles.subTitle} ${styles[appName]}`}>Enter their phone number</p>
                
                 <div className={styles.phoneInput}>
                    <PhoneInput
                        international
                        defaultCountry="GB"
                        value={phoneNumber}
                        onChange={setPhoneNumber}
                    />
                </div>

                <br></br>
                <Checkbox onChange={e => setIsAdmin(!isAdmin)} checked={isAdmin} name='App admin?'></Checkbox>
                <label className="ml-2">   Enable app admin</label>
                <br/>
                <br/>
                <Button severity="info" type="submit" disabled={loading} onClick={handleSubmit}>
                    {loading ? "Creating account..." : "Create account"}
                </Button>
            </div>
        </div>
    );
};

export default CreateUser;
